export default "__VITE_ASSET__465b0c39__"